import favouriteService from '../services/favourites'
import { createSlice } from '@reduxjs/toolkit'

import { setSuccessNotification, setErrorNotification } from './notificationReducer'
import { refreshBook } from './booksReducer'
import { refreshCourse } from './coursesReducer'
import { refreshPaper } from './papersReducer'
import { refreshPodcast } from './podcastsReducer'
import { refreshPolicy } from './policiesReducer'
import { refreshVideo } from './videosReducer'
import { refreshCodeNotebook } from './codenotebooksReducer'
import { refreshTerminology } from './terminologyReducer'
import { refreshResource } from './resourcesReducer'

const initialState = []

const REFRESH_BY_TYPE = {
    book: refreshBook,
    course: refreshCourse,
    paper: refreshPaper,
    podcast: refreshPodcast,
    policy: refreshPolicy,
    video: refreshVideo,
    codenotebook: refreshCodeNotebook,
    terminology: refreshTerminology,
}

// A write changes the `favourite` field on the resource; refetch so its slices see it.
const refreshResourceState = (dispatch, objectId, type) => {
    const refresh = REFRESH_BY_TYPE[type]
    if (refresh) dispatch(refresh(objectId))
    dispatch(refreshResource(objectId, type))
}

// toolkit sets up the redux and state
const favouriteSlice = createSlice({
    name: 'favourites',
    initialState,
    reducers: {
        setFavourites(state, action) {
            return action.payload
        },
        appendFavourite(state, action){
            state.push(action.payload)
        },
        destroyFavourite(state, action){
            return state.filter(favourite => favourite.id !== action.payload)
        }
    }
})

export const { setFavourites, appendFavourite, destroyFavourite } = favouriteSlice.actions

export const selectFavouriteId = (state, contentTypeId, objectId) => {
    const row = state.favourites.find(
        f => f.content_type === contentTypeId && f.object_id === objectId
    )
    return row ? row.id : null
}

export const createFavourite = (data, type) => {
    return async dispatch => {
        try {
            const fav = await favouriteService.create(data)
            dispatch(appendFavourite(fav))

            refreshResourceState(dispatch, data.object_id, type)

            dispatch(setSuccessNotification('Resource favourited!'))
            return true
        } catch {
            dispatch(setErrorNotification('Error favouriting resource'))
            return false
        }
    }
}

// Only the latest initializeFavourites call may write to the store.
let latestRequest = 0

export const initializeFavourites = () => {
    return async dispatch => {
        const request = ++latestRequest
        try {
            const favs = await favouriteService.retrieve()
            if (request !== latestRequest) return true
            dispatch(setFavourites(favs))
            return true
        } catch {
            if (request !== latestRequest) return true
            dispatch(setErrorNotification('Error retrieving favourites'))
            return false
        }
    }
}

export const deleteFavourite = (id, type, typeId) => {
    return async dispatch => {
        try {
            await favouriteService.destroy(id)
            dispatch(destroyFavourite(id))

            refreshResourceState(dispatch, typeId, type)

            dispatch(setSuccessNotification('Favourite removed!'))
            return true
        } catch {
            dispatch(setErrorNotification('Error deleting favourite'))
            return false
        }
    }
}

export default favouriteSlice.reducer
